module.exports = __webpack_public_path__ + "fonts/HalisR-Bold.8153f976.otf";